@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.doi-container {
  width: 100%;
  height: 7.5rem;
  background: $grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 4rem;

  @include mobile {
    margin-top: 3.5rem;

    & ~ div:nth-of-type(3) {
      padding-top: 0 !important;
    }
  }

  &.hide {
    display: none;
  }

  .doi-close {
    position: absolute;
    top: 0.75rem;
    right: 0.5rem;
    cursor: pointer;
  }

  .doi-text {
    margin-top: 1.5rem;
    color: $white;
    font-size: 1.125rem;
    font-weight: 300;

    @include mobile {
      font-size: 0.875rem;
      text-align: center;
    }
  }

  .doi-confirm-button {
    @include mobile {
      button {
        background: transparent;
        border: none;
        color: $white;
      }
    }
  }

  .icon svg {
    width: 1rem;
    height: 1rem;
    vertical-align: baseline;
  }

  /* Solid icons get a fill */
  .solid {
    fill: #888888;
    stroke: none
  }

}